// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--TYbIu","footerBottom":"footer-module--footer-bottom--29KJJ","footerLinks":"footer-module--footer-links--2xKUH"};